// extracted by mini-css-extract-plugin
export default {"linksList":"links-local__linksList___uRBb5628","link":"links-local__link___i-LYzZ+t"};